import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fre-example',
  templateUrl: './example.component.html',
  styleUrls: ['./example.component.sass']
})
export class ExampleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
